import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"
import i18next from 'i18next'
import { SUPPORTED_LANGUAGES, type SupportedLanguage } from './i18n'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function emailLanguage(): SupportedLanguage {
  // Get language from i18next
  const lang = i18next.language || navigator.language || ''

  // Find the matching supported language
  const supportedLang = SUPPORTED_LANGUAGES.find(supported =>
    lang === supported || lang.startsWith(supported + '-')
  )

  return supportedLang || 'en'
}

export function getLanguagePath(path: string): string {
  const lang = i18next.language || 'en'
  // Remove any existing language prefix and leading/trailing slashes
  const cleanPath = path.replace(/^\/[^/]+\/|^\/|\/$/g, '')
  return `/${lang}/${cleanPath}`
}

/**
 * Detects if the current environment is staging or dev based on URL or other indicators
 */
export function isStaging(): boolean {
  if (typeof window === 'undefined') return false;

  const hostname = window.location.hostname;
  const url = window.location.href;

  return hostname.includes('staging') ||
         url.includes('staging.');
}

export function isDev(): boolean {
  if (typeof window === 'undefined') return false;

  const hostname = window.location.hostname;
  const url = window.location.href;

  return hostname.includes('dev') ||
         url.includes('dev.');
}

/**
 * Formats discount percentage based on locale
 * - Western format: "66% OFF"
 * - Taiwan format: "3.4折" (34% of original price)
 */
export function formatDiscount(percentage: number, locale: string): string {
  if (locale === 'zh-TW') {
    // Taiwan uses "折" (zhe) system: 34折 means 34% of original price (66% OFF)
    const zhe = (100 - percentage);
    return `${zhe} 折`;
  }
  // Western format: "66% OFF"
  return `${percentage}% OFF`;
}